import './eventIndexController.js';
import './eventService.js';
import './eventIndexLazyLoad.js';

import 'Sass/views/_events.scss';